import type { ComponentProps } from 'react'
import RedditResults from '@/app/(app)/tools/reddit-brand-monitor/components/RedditResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `reddit` (Phase 3, Step 13 — Class B,
 * dashboard-reuse). This REPLACES the legacy inline `reddit` branch that lived
 * in `ToolDetailPanel` (a 4-stat row + a title/risk mentions list).
 *
 * REUSES the public `RedditResults` with `variant="dashboard"`, which hides the
 * public-only chrome (the email-share row, PlatformCTA, and the gradient
 * services CTA). The platform route (`/api/platform/tools/reddit-monitor`) runs
 * the same lib and returns the same `RedditMonitorResult`, so the dashboard
 * `data` maps straight onto the component — the dashboard now shows the full
 * rich report (score ring, AI analysis, the score-breakdown cards with their
 * `findingsFor` per-category bullets, subreddit breakdown, seeding matrix, the
 * full mention cards with show-10/show-all, and recommendations with blog
 * links) instead of the generic panel.
 *
 * Locked/teaser redaction is data-driven and lives in the public page (which
 * renders a teaser surface instead of this component when not unlocked); the
 * dashboard is paid-only and receives full data. This component adds/removes no
 * lock logic, so teaser behavior is unchanged.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still
 * works. Grade comes from `data.grade` via the reused component — never
 * recomputed; the Reddit 80/65/50/35 curve is untouched, and the deleted
 * generic deriveBreakdown is NOT reintroduced. Render-layer only.
 */
export function RedditDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof RedditResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <RedditResults result={result} variant='dashboard' />
    </div>
  )
}
